import { Box } from "@mui/system";
import type { DateTime } from "luxon";
import type { Dispatch, FC, SetStateAction } from "react";
import { DayViewContent } from "../../components/DayViewContent/DayViewContent";
import { DayViewContentActual } from "../../components/DayViewContent/DayViewContentActual";
import { DayViewGaps } from "../../components/DayViewGaps/DayViewGaps";
import { DRAWER_WIDTH_IN_PX } from "../../components/RecommendationsDrawer/utils";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import type { BaseNurseShift, Nurse } from "../../utils/models";
import { useIsDayGapsLayout } from "./useIsDayGapsLayout";

type DayViewContentWrapperProps = {
	date: DateTime;
	showActual: boolean;
	weekIndex: number;
	nurses: BaseNurseShift[];
	selectedNurse: Nurse | null;
	drawerOpen: boolean;
	selectedLocations: string[];
	setSelectedLocations: Dispatch<SetStateAction<string[]>>;
	availableLocations: string[];
};

export const DayScheduleContentWrapper: FC<DayViewContentWrapperProps> = ({
	date,
	showActual,
	weekIndex,
	nurses,
	selectedNurse,
	drawerOpen,
	selectedLocations,
	setSelectedLocations,
	availableLocations,
}) => {
	const { isHospitalView } = useHospitalData();
	// Only hospital demos (Hospital type + inhouse2). They get DM Sans and skip the gaps view.
	const isRealHospitalDemo = isHospitalView;
	const showGapsView = useIsDayGapsLayout();

	return (
		<Box
			data-hospital-demo={isRealHospitalDemo ? "true" : undefined}
			sx={{
				flex: 1,
				minHeight: 0,
				overflow: "auto",
				marginRight: drawerOpen ? `${DRAWER_WIDTH_IN_PX}px` : 0,
			}}
		>
			{showActual ? (
				<DayViewContentActual
					date={date}
					weekIndex={weekIndex}
					nurses={nurses}
					selectedNurse={selectedNurse}
					selectedLocations={selectedLocations}
					setSelectedLocations={setSelectedLocations}
					availableLocations={availableLocations}
				/>
			) : showGapsView ? (
				<DayViewGaps
					date={date}
					nurses={nurses}
					selectedNurse={selectedNurse}
					selectedLocations={selectedLocations}
					setSelectedLocations={setSelectedLocations}
					availableLocations={availableLocations}
				/>
			) : (
				<DayViewContent
					weekIndex={weekIndex}
					date={date}
					nurses={nurses}
					selectedNurse={selectedNurse}
					selectedLocations={selectedLocations}
					setSelectedLocations={setSelectedLocations}
					availableLocations={availableLocations}
				/>
			)}
		</Box>
	);
};
